<template>
  <modal-dialog
    size="lg"
    ref="modalTarget"
    :heading="heading"
    :heading-icon="headingIcon"
    :color="color"
    :cancel-action-copy="cancelActionCopy"
    :has-opener="false"
    showHeaderSeparator
  >
    <template #modal-body>
      <div class="py-6 space-y-8">
        <div
          class="space-y-2 text-sm"
          v-if="confirmationHeading || confirmationSubheading"
        >
          <h5
            v-if="confirmationHeading"
            class="font-semibold"
          >
            {{ confirmationHeading }}
          </h5>
          <p
            v-if="confirmationSubheading"
            class="text-gray-600"
          >
            {{ confirmationSubheading }}
          </p>
        </div>
        <slot />
      </div>
    </template>
    <template #primary-action>
      <button
        :disabled="isLoading"
        :class="primaryActionClass"
        @click="emit('click:confirm')"
      >
        {{ primaryActionCopy }}
      </button>
    </template>
  </modal-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { semanticColors } from '@/constants/colors';

const emit = defineEmits(['click:confirm']);

const props = defineProps({
  heading: {
    type: String,
    required: true,
  },
  headingIcon: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    validator: (value) => semanticColors.includes(value),
    default: 'neutral',
  },
  cancelActionCopy: {
    type: String,
    default: 'Cancel',
  },
  primaryActionCopy: {
    type: String,
    default: 'Confirm',
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  confirmationHeading: String,
  confirmationSubheading: String,
});

const primaryActionClass = computed(() => {
  return `btn btn-${props.color}`;
});

const modalTarget = ref(null);

const showModal = () => {
  modalTarget.value?.showModal();
};

const closeModal = () => {
  modalTarget.value?.closeModal();
};

defineExpose({
  showModal,
  closeModal,
});
</script>
